<!-- <div class="flex justify-center"> -->
    <h1 #placeOrderHeading tabindex="-1" class="visually-hidden">Navigated to Place order Screen</h1>
    <p-stepper [value]="activeStep" cleanStepPanelAccessibility [attr.role]="null">
        <p-step-list>
            <ng-container *ngFor="let step of activeSteps;let i = index">
                <p-step *ngIf="step.visible" [value]="step.value" class="">
                    <ng-template #content let-value="value">
                        <div class="inner-container text-center">
                            <button
                                id="place-order-stepper-{{i+1}}"
                                type="button"
                                class="step-circle"
                                [ngClass]="{
                                    'active': activeStep === step.value,
                                    'completed': step.status === 'completed' && activeStep != step.value,
                                    'inComplete': step.status === 'inComplete' && activeStep != step.value
                                }"
                                (click)="setCurrentStep(step)"
                                [attr.aria-label]="
                                    activeStep === step.value
                                    ? step.label + ' step is currently active'
                                    : step.status === 'completed'
                                        ? step.label + ' step completed. Click to revisit this step.'
                                        : step.label + ' step is not yet available, first complete active step'
                                ">
                                <span class="white-bdr">
                                    <i [ngClass]="step.status === 'completed' && activeStep != step.value ? 'fa fa-check' : step.icon"></i>
                                </span>
                            </button>
                            <br>
                            <label aria-hidden="true" [ngClass]="">{{step.label}}</label>

                        </div>
                    </ng-template>
                </p-step>
            </ng-container>

        </p-step-list>
        <p-step-panels>
            <p-step-panel cleanStepPanelAccessibility [value]="1">
                <ng-template #content>
                    <app-order-info [formData]="orderInfoData" (orderTypeChange)="updateStepper($event)" (formChanged)="onFormChange()" [states]="states" [editOrder]="isEditOrder"></app-order-info>
                </ng-template>
            </p-step-panel>

            <p-step-panel cleanStepPanelAccessibility [value]="2">
                <ng-template #content>
                    <app-subjects [formData]="subjectsData" [orderType]="orderInfoData?.selectedCategory" (formChanged)="onFormChange()" [editOrder]="isEditOrder"></app-subjects>
                </ng-template>
            </p-step-panel>

            <p-step-panel cleanStepPanelAccessibility [value]="3">
                <ng-template #content>
                    <app-subpoena [subjects]="subjectsData" [formData]="subpoenaData" (formChanged)="onFormChange()" [orderInfoAccountName] ="orderInfoData?.orderInfoAccountName" [states]="states" [editOrder]="isEditOrder"></app-subpoena>
                </ng-template>
            </p-step-panel>
            <p-step-panel cleanStepPanelAccessibility [value]="4">
                <ng-template #content>
                    <app-authorization [subjects]="subjectsData" [formData]="authorizationData" (formChanged)="onFormChange()" [states]="states" [editOrder]="isEditOrder"></app-authorization>
                </ng-template>
            </p-step-panel>
            <p-step-panel cleanStepPanelAccessibility [value]="5">
                <ng-template #content>
                    <app-records [subjects]="subjectsData" [formData]="recordsData" [selectedCategory]="orderInfoData?.selectedCategory" [vocabDocumentTagsData]="vocabDocumentTagsData" (formChanged)="onFormChange()" [states]="states" [editOrder]="isEditOrder" (addProviderValidate)="onAddProviderValidate()"></app-records>
                </ng-template>
            </p-step-panel>
        </p-step-panels>
    </p-stepper>
      <hr />
        <div class="d-flex justify-content-end">
            <p-button id="place-order-back" label="Back" severity="secondary" (onClick)="onPrevious()" [disabled]="activeStep === 1" />
            <p-button id="place-order-next-step" *ngIf="!isLastStep()" label="Next Step" (onClick)="onNext()" class="ms-3" />
            <p-button id="place-order-finish" *ngIf="isLastStep()" label="Finish" (onClick)="onFinish()" class="ms-3" [disabled]="isFormSubmitted"/>
        </div>
    <p-toast position="top-center" severity="warn" />
<!-- </div> -->